import { TIME_UPDATE_INTERVAL_FPS } from 'configuration/defaults';

export const now = () => new Date().getTime();
export const HOUR_MS = 3600000;
export const MINUTE_SECONDS = 60;
export const HOUR_SECONDS = MINUTE_SECONDS * 60;
export const DAY_SECONDS = 24 * HOUR_SECONDS;
export const nextTick = operation => requestAnimationFrame(operation);
export const fpsResToMS = (resolution = TIME_UPDATE_INTERVAL_FPS) => 1000 / resolution;

export const durationToISO = (seconds = 0) => {
    const days = Math.floor(seconds / DAY_SECONDS);

    seconds = seconds - (days * DAY_SECONDS);
    const hours = Math.floor(seconds / HOUR_SECONDS);

    seconds = seconds - (hours * HOUR_SECONDS);
    const minutes = Math.floor(seconds / MINUTE_SECONDS);

    seconds = seconds - (minutes * MINUTE_SECONDS);

    const fmt = (val, label) => val ? val + label : '';

    return 'PT' + fmt(days,'D') + fmt(hours,'H') + fmt(minutes,'M') + fmt(seconds,'S');
};

export const minimumResolution = (list = []) => {
    const [minimum] = list.map(l => l.resolution).sort((a,b) => b - a);
    return minimum;
}

export class IntervalTracker {
    constructor({ resolution = TIME_UPDATE_INTERVAL_FPS }) {
        this.resolution = fpsResToMS(resolution);
        this.lastCheck = new Date().getTime();
    }

    get elasped() {
        const currentTime = now();
        if (currentTime > this.lastCheck + this.resolution) {
            this.lastCheck = currentTime;
            return true;
        }

        return false;
    }
}

// adapted from https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
export const throttle = (fn, limit) => {
    let throttling;

    return (...args) => {
        if (!throttling) {
            fn(...args);
            throttling = true;

            setTimeout(() => throttling = false, limit)
        }
    }
}

export const later = fn => requestAnimationFrame(fn);